import React from 'react';
import moment from 'moment';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import { Ban, Clock, Crown, MonitorPlay, Radio, Ticket, TriangleAlert, Unlock, UserPlus, Users } from 'lucide-react';
import { duration } from './format';

const Card = ({ icon: Icon, label, value, sub, tone = '' }) => (
    <div className={`up-stat ${tone}`}>
        <span className='up-stat-icon'><Icon size={18} /></span>
        <div>
            <p className='up-stat-value'>{value}</p>
            <p className='up-stat-label'>{label}</p>
            {sub && <p className='up-stat-sub'>{sub}</p>}
        </div>
    </div>
)

const Chart = ({ title, data, color }) => (
    <div className='up-chart'>
        <p className='up-chart-title'>{title} <span>· 30 jours · {data.reduce((n, d) => n + d.count, 0)}</span></p>
        <ResponsiveContainer width='100%' height={110}>
            <BarChart data={data} margin={{ top: 6, right: 0, left: 0, bottom: 0 }}>
                <XAxis dataKey='day' tickFormatter={(d) => moment(d).format('DD/MM')} tick={{ fill: '#8f909c', fontSize: 10 }} axisLine={false} tickLine={false} interval={6} />
                <Tooltip
                    cursor={{ fill: 'rgba(255,255,255,0.04)' }}
                    contentStyle={{ background: '#1b1822', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, fontSize: 12 }}
                    labelFormatter={(d) => moment(d).format('DD/MM/YYYY')}
                    formatter={(v) => [v, title]}
                />
                <Bar dataKey='count' fill={color} radius={[4, 4, 0, 0]} isAnimationActive={false} />
            </BarChart>
        </ResponsiveContainer>
    </div>
)

/** Chiffres du projet (GET /stats) : cartes + inscriptions et déblocages par jour. */
const UpStats = ({ stats }) => {
    if (!stats) return <div className='up-stats skeleton'></div>
    const u = stats.users
    return (
        <>
            <div className='up-stats'>
                <Card icon={Users} label='Users' value={u.total} sub={`${u.active} actifs`} />
                <Card icon={Radio} label='En ligne' value={u.online} sub={`${u.seen24h} connectés 24 h`} tone='live' />
                <Card icon={MonitorPlay} label='En lecture' value={u.watchingNow ?? 0} sub='films, séries, sport' tone='live' />
                <Card icon={Crown} label='Premium' value={u.premium} sub={`${u.free} gratuits`} tone='gold' />
                <Card icon={Ban} label='Bloqués' value={u.blocked} sub={`${u.suspended} temporairement`} tone={u.blocked || u.suspended ? 'ko' : ''} />
                <Card icon={UserPlus} label='Nouveaux 7 j' value={u.new7d} sub={`${u.new24h} en 24 h · ${u.new30d} en 30 j`} />
                <Card icon={TriangleAlert} label='Avertissements' value={stats.warnings.total} sub={`${stats.warnings.last24h} en 24 h`} tone={stats.warnings.last24h ? 'warn' : ''} />
                <Card icon={Unlock} label='Vidéos débloquées' value={stats.unlocks.total} sub={`${stats.unlocks.last24h} en 24 h`} />
                <Card icon={Clock} label='Temps regardé' value={duration(stats.watch.seconds)} sub={`${stats.watch.videos} vidéos · ${stats.watch.finished} finies`} />
                <Card icon={Ticket} label='Invitations dispo' value={stats.invites.available} sub={`${stats.invites.used} utilisées`} />
            </div>
            <div className='up-charts'>
                <Chart title='Inscriptions' data={stats.charts.signups} color='#9754e3' />
                <Chart title='Vidéos débloquées' data={stats.charts.unlocks} color='#00d8dc' />
            </div>
        </>
    )
}

export default UpStats;
